import React, { PropTypes, Component } from 'react';
import './style.less';
import math from '../../utils/math';
const { accMul, accAdd, accSub, accDiv } = math;
import tools from "../../utils/tools";

export default class InputItem extends Component {
  state = {}

  toThousands(num) {
    if (!num) {
      return num;
    }
    num = num.toString();
    var s, e;
    if (num.indexOf('.') > -1) {
      s = num.substr(0, num.indexOf('.'));
      e = num.substr(num.indexOf('.'));
    } else {
      s = num;
      e = '';
    }
    return s.replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') + e;
  }

  formatPrecisionValue(value, maxLength, precision, preMaxCheck = false) {
    if (!value) {
      return value;
    }
    value = value.toString();
    if (maxLength) {
      if (value.indexOf('.') > -1) {
        let sp = value.split('.');
        value = sp[0].substr(0, maxLength - precision) + '.' + sp[1].substr(0, precision);
      } else {
        value = value.substr(0, maxLength - precision);
      }
    }
    if (precision != undefined) {
      if (preMaxCheck) {
        if (value.indexOf('.') > -1 && value.substr(value.indexOf('.') + 1).length > precision) {
          return parseFloat(value).toFixed(precision);
        }
      } else {
        // && value.indexOf('.') > -1 && value.substr(value.indexOf('.') + 1).length > precision
        return parseFloat(value).toFixed(precision);
      }
    }
    const v = value;
    if (isNaN(v)) {
      return '';
    }
    return v;
  }

  parseValue(value) {
    if (this.props.type === 'numtextbox') {
      if (!value && value !== 0) {
        return {
          value,
          text: value
        };
      }
      let text;
      if (this.props.percent) {
        value = this.formatPrecisionValue(value, this.props.maxLength, this.props.precision, true);
        text = accMul(value, 100) + '%';
        if (isNaN(value)) {
          value = '';
          text = '';
        }
      } else {
        value = value.toString().replace(/,/g, '');
        value = this.formatPrecisionValue(value, this.props.maxLength, this.props.precision, true);
        text = this.toThousands(value);
      }
      return {
        value,
        text
      };
    } else {
      return {
        value,
        text: value
      };
    }
  }

  constructor(props) {
    super(props);
    this.state = this.parseValue(props.value);
  }

  componentWillReceiveProps(nextProps) {
    this.setState(this.parseValue(nextProps.value));
  }

  handleChange = (e) => {
    // const withDot = e.target.value.endsWith('.');
    const withDot = this.props.type === 'numtextbox' ? e.target.value.endsWith('.') : false;
    const value = this.parseValue(e.target.value.toString().trim());//接口数据
    const valueText = this.parseValue(e.target.value);//页面显示值
    this.setState({ ...valueText, withDot });
    if (this.props.onChange) {
      this.props.onChange(value);
    }
  }

  handleFocus = () => {
    this.input = true;
    // this.setState({
    //   input: true
    // });
  }

  handleBlur = (e) => {
    // this.setState({
    //   input: false
    // });
    this.input = false;
    // this.props.onBlur && this.props.onBlur();
    if (this.props.type == 'numtextbox') {
      e.target.value = parseFloat(e.target.value);
      this.handleChange(e);
    }
  }

  inputValue() {
    const value = this.input ? (tools.isNull(this.state.value) ? '' : this.state.value) + (this.state.withDot && this.state.value.indexOf('.')<0 ? '.' : '') : (tools.isNull(this.state.value) ? '' : this.state.value)
    return value;
  }


  render() {
    const {
      maxLength,
      type,
      disabled
    } = this.props;
    return (
      <div className='inputItem' >
        <input type={type == 'numtextbox' ? 'number': ''} value={(() => this.inputValue())()} onFocus={this.handleFocus}
          placeholder='请输入'
          onBlur={this.handleBlur} onChange={this.handleChange} maxLength={maxLength > 0 ? maxLength : undefined}
          disabled={disabled}
          />
      </div>
    )
  }

}
